(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pet-video-reviews"] && !Shopify.designMode) return;
  try {
    
(function() {
    // ---------- DOM 元素 ----------
    const trackDom = document.getElementById('videoTrackDom');
    const cardItems = Array.from(document.querySelectorAll('.video-card-item'));
    const prevBtn = document.querySelector('.arrow-prev');
    const nextBtn = document.querySelector('.arrow-next');
    const dotWrap = document.getElementById('dotWrapDom');
    const modalWrap = document.getElementById('videoModalDom');
    const modalVideo = document.getElementById('modalPlayVideo');
    const closeModalBtn = document.getElementById('closeModal');

    // ---------- 辅助变量 ----------
    let perPage = getPerPage();       // 每页显示数量
    let currentPage = 0;
    let resizeTimer = null;
    let isTransitioning = false;      // 避免快速点击冲突

    // 获取每页数量（响应式）
    function getPerPage() {
        return window.innerWidth < 750 ? 2 : 3;
    }

    // 获取总页数
    function getTotalPage() {
        return Math.ceil(cardItems.length / perPage);
    }

    // ---------- 懒加载观察器：仅当视频卡片接近视口时加载并播放 ----------
    // 优化点：一开始不会加载所有视频，只加载首屏可见卡片
    const videoObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            const videoElem = entry.target;
            if (entry.isIntersecting) {
                // 如果还没有真正加载视频源（data-src存在未加载）
                if (videoElem.dataset.src && !videoElem.src) {
                    const srcUrl = videoElem.dataset.src;
                    // 设置video的src并加载
                    videoElem.src = srcUrl;
                    videoElem.removeAttribute('data-src');
                    // 加载后尝试播放（自动播放策略可能被浏览器阻止，但muted可以）
                    videoElem.load();
                    videoElem.play().catch(e => {
                        // 静默失败，用户悬停或点击时不影响
                        if (e.name !== 'NotAllowedError') console.warn(e);
                    });
                } else if (videoElem.src && videoElem.paused) {
                    // 已加载但暂停，因为滚动视野内就播放 (自动策略静音可播)
                    videoElem.play().catch(() => {});
                }
                // 一旦加载完成，取消观察以节省性能
                if (videoElem.src || videoElem.dataset.src === undefined) {
                    videoObserver.unobserve(videoElem);
                }
            } else {
                // 离开视口时暂停释放资源，但不销毁src（保留已加载状态, 防止重复网络请求）
                if (videoElem.src && !videoElem.paused) {
                    videoElem.pause();
                }
            }
        });
    }, { threshold: 0.2, rootMargin: '100px' });  // 提前100px开始加载

    // 为每个卡片内video添加懒加载机制 + 播放暂停控制（基于可见性）
    function initLazyVideos() {
        cardItems.forEach(card => {
            const videoElem = card.querySelector('video');
            if (!videoElem) return;
            // 如果video标签原本有src的则收集到data-src移除真实src，改用懒加载统一
            if (videoElem.src && !videoElem.dataset.src) {
                const originalSrc = videoElem.src;
                videoElem.removeAttribute('src');
                videoElem.dataset.src = originalSrc;
                // 清除已有的source也可能存在src，清理避免直接加载
                const sources = videoElem.querySelectorAll('source');
                sources.forEach(source => {
                    if (source.src && !source.dataset.src) {
                        source.dataset.src = source.src;
                        source.removeAttribute('src');
                    }
                });
            } else if (!videoElem.dataset.src) {
                // 如果根本没有视频源但是有data-属性（从liquid传入）
                const modalSrc = card.dataset.videosrc;
                if (modalSrc && !videoElem.src && !videoElem.dataset.src) {
                    videoElem.dataset.src = modalSrc;
                }
            }
            // 观察每个视频元素
            videoObserver.observe(videoElem);
        });
    }

    // 补充：由于resize或动态dom变动，重新刷新懒加载绑定，但此处简单确保所有video都被观察到
    function refreshLazyObservers() {
        document.querySelectorAll('.video-card-item video').forEach(vid => {
            if (!vid.dataset.src && vid.src) return;
            videoObserver.observe(vid);
        });
    }
    
    // 手动加载前两张内的视频（提高首屏体验）
    function warmUpFirstScreen() {
        const visibleCards = cardItems.slice(0, perPage);
        visibleCards.forEach(card => {
            const vid = card.querySelector('video');
            if (vid && vid.dataset.src) {
                // 主动提前加载但不影响性能雪崩，只加载少部分
                if (vid.dataset.src) {
                    vid.src = vid.dataset.src;
                    vid.removeAttribute('data-src');
                    vid.load();
                    vid.play().catch(() => {});
                    videoObserver.unobserve(vid);
                }
            }
        });
    }

    // ---------- 渲染轮播点 (粉色圆点) ----------
    function renderDots() {
        if (!dotWrap) return;
        const total = getTotalPage();
        dotWrap.innerHTML = '';
        for (let i = 0; i < total; i++) {
            const dot = document.createElement('button');
            dot.className = 'dot-item';
            if (i === currentPage) dot.classList.add('active');
            dot.dataset.page = i;
            dot.setAttribute('aria-label', `第${i+1}页`);
            dot.addEventListener('click', (e) => {
                e.stopPropagation();
                if (isTransitioning) return;
                if (i !== currentPage) {
                    currentPage = i;
                    updateSlider(true);
                }
            });
            dotWrap.appendChild(dot);
        }
    }

    // 更新滑块位移 & 激活点样式
    function updateSlider(animate = true) {
        if (!cardItems.length || isTransitioning) return;
        const firstCard = cardItems[0];
        if (!firstCard) return;
        const cardWidth = firstCard.offsetWidth;
        if (cardWidth === 0) return;
        const translateX = -(currentPage * perPage * cardWidth);
        if (!animate) {
            trackDom.style.transition = 'none';
        } else {
            trackDom.style.transition = 'transform 0.4s cubic-bezier(0.2, 0.9, 0.4, 1.1)';
        }
        trackDom.style.transform = `translateX(${translateX}px)`;
        
        // 强制重绘后恢复transition
        if (!animate) {
            trackDom.offsetHeight;
            trackDom.style.transition = '';
        }
        
        // 更新dots激活状态
        const dots = document.querySelectorAll('.dot-item');
        dots.forEach((dot, idx) => {
            if (idx === currentPage) dot.classList.add('active');
            else dot.classList.remove('active');
        });
        
        // 轮播滑动完成后解锁，用于节流
        if (animate) {
            isTransitioning = true;
            const onTransitionEnd = () => {
                isTransitioning = false;
                trackDom.removeEventListener('transitionend', onTransitionEnd);
            };
            trackDom.addEventListener('transitionend', onTransitionEnd, { once: true });
            // 保险: 0.5s后强制解锁
            setTimeout(() => {
                if (isTransitioning) isTransitioning = false;
            }, 500);
        }
    }

    // 上一页下一页逻辑 + 边界保护
    function goPrev() {
        if (isTransitioning) return;
        if (currentPage > 0) {
            currentPage--;
            updateSlider(true);
        }
    }
    
    function goNext() {
        if (isTransitioning) return;
        if (currentPage < getTotalPage() - 1) {
            currentPage++;
            updateSlider(true);
        }
    }
    
    // 绑定按钮事件
    if (prevBtn) prevBtn.addEventListener('click', goPrev);
    if (nextBtn) nextBtn.addEventListener('click', goNext);
    
    // ---------- 全屏弹窗（黑幕）支持全屏按钮 ----------
    function openModal(videoSrc) {
        if (!modalWrap || !modalVideo) return;
        // 设置视频地址并强制加载
        modalVideo.src = videoSrc;
        modalVideo.load();
        modalWrap.style.display = 'flex';
        modalWrap.classList.add('show');
        // 自动播放（由于用户主动点击触发的play不受限）
        modalVideo.play().catch(err => {
            console.warn("自动播放失败，用户需点击播放按钮", err);
        });
        // 进入全屏模式体验: 如果用户点击全屏图标交由原生控件管理，但也可以监听双击全屏? 但浏览器原生支持挺好，但额外提供全屏快捷键
        // 同时给modalVideo添加双击全屏功能
        if (!modalVideo.hasFullscreenListener) {
            modalVideo.addEventListener('dblclick', () => {
                if (modalVideo.requestFullscreen) {
                    modalVideo.requestFullscreen().catch(e => console.warn(e));
                }
            });
            modalVideo.hasFullscreenListener = true;
        }
    }

    function closeModal() {
        if (!modalWrap) return;
        modalWrap.style.display = 'none';
        modalWrap.classList.remove('show');
        if (modalVideo) {
            modalVideo.pause();
            modalVideo.src = '';    // 释放资源
            modalVideo.load();
        }
    }
    
    // 绑定弹窗关闭事件
    if (closeModalBtn) closeModalBtn.addEventListener('click', closeModal);
    if (modalWrap) {
        modalWrap.addEventListener('click', (e) => {
            if (e.target === modalWrap) closeModal();
        });
    }
    
    // 卡片点击播放全屏弹窗
    function bindCardClick() {
        cardItems.forEach(card => {
            const holder = card.querySelector('.video-holder');
            if (!holder) return;
            // 防止重复绑定
            if (holder.dataset.bind) return;
            holder.dataset.bind = 'true';
            const videoSrc = card.dataset.videosrc;
            if (!videoSrc) return;
            holder.addEventListener('click', (e) => {
                e.stopPropagation();
                // 额外优化：如果当前卡片的小视频正在播放，打开弹窗前先暂停节省性能
                const miniVideo = card.querySelector('video');
                if (miniVideo && !miniVideo.paused) miniVideo.pause();
                openModal(videoSrc);
            });
        });
    }
    
    // 处理resize事件 (重新计算每页数量，重置位置)
    let resizeTimeout;
    window.addEventListener('resize', () => {
        if (resizeTimeout) clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            const newPerPage = getPerPage();
            if (newPerPage !== perPage) {
                perPage = newPerPage;
                // 确保当前页面不超过总页数
                const total = getTotalPage();
                if (currentPage >= total) currentPage = Math.max(0, total - 1);
                // 重置位移，无动画
                updateSlider(false);
                renderDots();
            } else {
                // 每页数量未变，但卡片宽度可能因窗口变化，需重新定位滑动位置
                updateSlider(false);
            }
            // 重新观察懒加载区域（保证resize后重新观察未加载的视频）
            refreshLazyObservers();
        }, 150);
    });
    
    // ---------- 性能优化: 同时加载所有视频改为视野内加载，页面启动流畅 ----------
    // 立即初始化懒加载观察器
    initLazyVideos();
    
    // 渲染点和初次布局
    function init() {
        if (!cardItems.length) return;
        renderDots();
        updateSlider(false);
        bindCardClick();
        warmUpFirstScreen();
        // 额外: 如果由于异步加载导致卡片的video被重复绑定，再次确保所有未观察的观察
        setTimeout(() => {
            refreshLazyObservers();
        }, 300);
    }
    
    init();

    // 当 Shopify 动态加载或 section 重新渲染时，确保 Modal 能处理新卡片（通过 MutationObserver 监听 videoTrackDom 变化）
    const observerDomChange = new MutationObserver((mutations) => {
        let needRefresh = false;
        for (let mutation of mutations) {
            if (mutation.type === 'childList' && mutation.addedNodes.length) {
                needRefresh = true;
                break;
            }
        }
        if (needRefresh) {
            // 重新获取卡片列表，绑定点击事件，更新轮播逻辑
            const newCardList = Array.from(document.querySelectorAll('.video-card-item'));
            // 更新外部变量
            cardItems.length = 0;
            cardItems.push(...newCardList);
            // 重新绑定
            bindCardClick();
            // 重新初始化懒加载video
            document.querySelectorAll('.video-card-item video').forEach(vid => {
                if (vid.dataset.src && !vid.src) {
                    videoObserver.observe(vid);
                }
            });
            renderDots();
            currentPage = 0;
            updateSlider(false);
        }
    });
    if (trackDom) observerDomChange.observe(trackDom, { childList: true, subtree: false });
    
    // 键盘左右键支持 (全屏时esc关闭)
    window.addEventListener('keydown', (e) => {
        if (modalWrap && modalWrap.style.display === 'flex') {
            if (e.key === 'Escape') {
                closeModal();
                e.preventDefault();
            }
            return;
        }
        if (e.key === 'ArrowLeft') {
            goPrev();
            e.preventDefault();
        } else if (e.key === 'ArrowRight') {
            goNext();
            e.preventDefault();
        }
    });
})();

  } catch(e) { console.error(e); }
})();
})();
